import { Fragment, useContext } from 'react';
import { AppContext } from '../contexts/AppContext';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row } from 'react-bootstrap';
import { Divider } from 'theme-ui';
import { DeliveryStatusType, PackageStatusType, TaskType } from '../contexts/contextTypes';
import TrackingHistory from '../components/TrackingHistory';
import DeliveryInstructions from '../components/DeliveryInstructions';
import CustomerSupport from '../components/CustomerSupport';
import BankIDVerification from '../components/BankIDVerification';
import MapContainer from '../components/Dashboard/MapContainer';
import FailedContainer from '../components/Dashboard/FailedContainer';
import PendingContainer from '../components/Dashboard/PendingContainer';
import CompletedContainer from '../components/Dashboard/CompletedContainer';
import LockerDeliveryContainer from '../components/Dashboard/LockerDeliveryContainer';
import DeliveryRequirementBadge from '../components/DeliveryInstructions/DeliveryRequirementBadge';

const Dashboard = ({ isCustomerService }: { isCustomerService: boolean }) => {
  const { t } = useTranslation();
  const { trackingDetails } = useContext(AppContext);
  const taskStatus = trackingDetails?.task?.status;

  const showCustomerSupport =
    !isCustomerService &&
    (taskStatus === DeliveryStatusType.FAILED ||
      trackingDetails?.package?.status === PackageStatusType.CANCELLED ||
      (trackingDetails?.package?.originalCompleteAfter !== trackingDetails?.task?.completeAfter &&
        trackingDetails?.package?.originalCompleteBefore !== trackingDetails?.task?.completeBefore) ||
      (taskStatus === DeliveryStatusType.IN_PROGRESS &&
        trackingDetails?.eta?.predictedArrival &&
        trackingDetails?.eta.lowerBound &&
        new Date(trackingDetails?.eta?.lowerBound).getTime() < Date.now() &&
        trackingDetails?.stopsAhead === 0));

  const isLockerDelivery = trackingDetails?.task?.taskType && [TaskType.LOCKER_DELIVERY, TaskType.LOCKER_PICKUP].includes(trackingDetails.task.taskType);

  return (
    <Fragment>
      {trackingDetails?.task?.taskType === TaskType.LOCKER_PICKUP ? (
        <FailedContainer />
      ) : [DeliveryStatusType.IN_PROGRESS, DeliveryStatusType.CONSUMER_COLLECTION].includes(taskStatus as DeliveryStatusType) ? (
        <MapContainer />
      ) : taskStatus === DeliveryStatusType.COMPLETED ? (
        <CompletedContainer />
      ) : taskStatus === DeliveryStatusType.FAILED ? (
        <FailedContainer />
      ) : (
        <PendingContainer isCustomerService={isCustomerService} />
      )}
      <Divider style={{ marginTop: 20 }} />

      {isLockerDelivery ? (
        <LockerDeliveryContainer isCustomerService={isCustomerService} />
      ) : (
        <Fragment>
          <DeliveryRequirementBadge
            userRequirements={trackingDetails?.package?.userDeliveryRequirements}
            partnerRequirements={{
              identificationCheckRequired: trackingDetails?.task?.identificationCheckRequired,
              recipientMinimumAge: trackingDetails?.task?.recipientMinimumAge,
              recipientMustMatchEndCustomer: trackingDetails?.task?.recipientMustMatchEndCustomer,
              requireSignature: trackingDetails?.task?.requireSignature
            }}
          />
          <BankIDVerification isCustomerService={isCustomerService} />
        </Fragment>
      )}

      <TrackingHistory />
      <Divider style={{ marginTop: 20, marginBottom: isLockerDelivery ? 10 : 0 }} />
      {!isLockerDelivery && (
        <Container>
          <Row className="package_history">
            <Col>
              <div className="package_history--header">{t('deliveryInstructions.heading')}</div>
              <DeliveryInstructions isCustomerService={isCustomerService} />
            </Col>
          </Row>
        </Container>
      )}
      {showCustomerSupport && <CustomerSupport />}
    </Fragment>
  );
};

export default Dashboard;
